import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type CheckInContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null } | null };


export type CheckInContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type CheckInContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type CheckInContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const CheckInContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment CheckInContentCard on CheckinType {
  id
  name
  type
  duration
  description
  status
  performance {
    id
    status
    estimatedTimeSpent
  }
}
    `;
export const CheckInContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment CheckInContentCardWithUserPerformance on CheckinType {
  id
  name
  type
  duration
  description
  status
  performance {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;